<template>
  <input
    type="checkbox"
    class="ag-checkbox-input"
    :checked="isChecked"
    :disabled="isDisabled"
    @change="handleChange"
  />
</template>

<script>
import Vue from 'vue';
import get from 'lodash/get';

export default Vue.extend({
  name: 'TsgScopedCheckboxCellRenderer',

  computed: {
    tsgKey() {
      if (!this.params) return null;
      const parent = this.params.context.componentParent;

      // If this column is a grouped TSG column, extract the TSG key from the column id
      const colId = get(this.params, 'column.colId', '');
      const colTsg = parent.getTsgKeyFromColId(colId);
      if (colTsg) return colTsg;

      // Fallback: use node's TSG key (non-grouped mode where each row has its own toolStoreGroupKey)
      if (!this.params.node) return null;
      return parent.getNodeTsgKey(this.params.node);
    },

    isChecked() {
      if (!this.params) return false;
      const productKey = get(this.params, 'data.productKey');
      const selections = this.params.context.componentParent.selectedRowsByTsg[this.tsgKey];

      return selections && selections.has(productKey);
    },

    isDisabled() {
      // Read disabled state from params (computed by parent via isSelectionDisabled)
      return get(this.params, 'disabled', false);
    },
  },

  methods: {
    handleChange(event) {
      if (this.isDisabled) return;

      const productKey = get(this.params, 'data.productKey');
      if (!productKey) return;

      const parent = this.params.context.componentParent;
      const tsgKey = this.tsgKey;
      if (!tsgKey) return;

      // Initialize selection set if needed
      if (!parent.selectedRowsByTsg[tsgKey]) {
        parent.$set(parent.selectedRowsByTsg, tsgKey, new Set());
      }

      const selections = parent.selectedRowsByTsg[tsgKey];

      if (event.target.checked) {
        selections.add(productKey);
      } else {
        selections.delete(productKey);
      }

      // Update header checkbox state using column ID
      const headerKey = get(this.params, 'column.colId');
      if (headerKey) {
        parent.updateHeaderCheckbox(headerKey);
      }

      parent.updateBulkSelectionState();
    },
  },
});
</script>
